import React, { useEffect, useState } from "react";
import { Stack, popoverClasses } from "@mui/material";
import _ from "lodash";
import "../index.css";
import axios from "axios";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { DatePicker } from "antd";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import GenerateThumbnail from "./generateThumbnails";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  conflictDataActions,
  feedbackActions,
  shelfViewFeedbackActions,
  thumbnailStoreActions,
} from "../store/store";
import "./annotator.css";
import AnimatedPopup from "./Popup/AnimatedPopup";
import { socket } from "../socket";
import { setOpen } from "../store/ShelfView/popover";
import AnnotatorSidebar from "./annotatorSidebar";
import AnnotatorRightSidebar from "./AnnotatorRightSidebar";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";

const { RangePicker } = DatePicker;

const ThumbnailViewer = () => {
  const dispatch = useDispatch();
  const { loading, selectedZoom } = useSelector(
    (state) => state.shelfViewFeedbackStore
  );
  const [anchor, setAnchor] = React.useState(null);
  const [toggleRightSidebar, setToggleRightSidebar] = useState(false);
  const [hoverRightSidebar, setHoverRightSidebar] = useState(true);

  const { user, username, userId } = useSelector((state) => state.userStore);
  const { cursorDetails, discardThumbnails } = useSelector(
    (state) => state.thumbnailStore
  );
  //console.log(cursorDetails,"cursor details------- verified")
  const thumbnails = cursorDetails.thumbnailDetails;
  console.log(thumbnails);
  const endOfThumbnailList = cursorDetails.endOfThumbnailList;
  console.log(endOfThumbnailList);
  const currentKey = cursorDetails.currentKey;

  const [infiniteLoadingLowerbound, setInfiniteLoadingLowerbound] = useState(0);
  const [infiniteLoadingUpperbound, setInfiniteLoadingUpperbound] =
    useState(200);
  const [thumbnailsToDisplay, setThumbnailsToDisplay] = useState([]);
  const [infiniteLoadingMessage, setInfiniteLoadingMessage] = useState("");
  const [selectedThumbnails, setSelectedThumbnails] = useState([]);

  const toggleSidebarFunc = () => {
    setToggleRightSidebar((prev) => !prev);
  };
  const handleMouse = () => {
    setHoverRightSidebar((prev) => !prev);
  };

  //console.log('htumbnail checl', thumbnails, thumbnailsToDisplay);

  const markAsDiscarded = async (item) => {
    const thumbnailData = [...cursorDetails.thumbnailDetails];
    const updatedThumbnailDetails = thumbnailData.map((r) => {
      let obj = { ...r };
      if (
        obj.thumbnailName === item.thumbnailName &&
        obj.xmin === item.xmin &&
        obj.xmax === item.xmax &&
        obj.ymin === item.ymin &&
        obj.ymax === item.ymax
      ) {
        obj.discarded = !obj.discarded;
        return obj;
      } else {
        return obj;
      }
    });
    const thumbnailIndex = selectedThumbnails.findIndex(
      (thumbnail) => thumbnail.thumbnailName === item.thumbnailName
    );

    if (thumbnailIndex === -1) {
      // Thumbnail not present, add it to the array
      setSelectedThumbnails([...selectedThumbnails, item]);
    } else {
      // Thumbnail already present, remove it from the array
      const updatedSelectedThumbnail = [...selectedThumbnails];
      updatedSelectedThumbnail.splice(thumbnailIndex, 1);
      setSelectedThumbnails(updatedSelectedThumbnail);
    }

    dispatch(thumbnailStoreActions.markAsDiscarded(updatedThumbnailDetails));
  };

  console.log(selectedThumbnails, "selected-->  ");
  useEffect(() => {
    const container = document.querySelector(".thumbnail-grid");

    if (thumbnails.length === 0) {
      console.log("scrolling to top");
      container.scrollTop = 0;
    }

    const handleScroll = () => {
      if (container) {
        const { scrollHeight, scrollTop, offsetHeight } = container;
        const scrollPercentage =
          (scrollTop / (scrollHeight - offsetHeight)) * 100;
        const thresholdPercentage = 95;

        if (scrollPercentage >= thresholdPercentage) {
          // fetaching more data
          let updatedUpperBound = infiniteLoadingUpperbound + 10;

          if (updatedUpperBound >= thumbnails.length) {
            updatedUpperBound = thumbnails.length;
          }

          setInfiniteLoadingLowerbound(infiniteLoadingLowerbound);
          setInfiniteLoadingUpperbound(updatedUpperBound);
          setThumbnailsToDisplay(
            thumbnails.slice(infiniteLoadingLowerbound, updatedUpperBound)
          );
        }
      }
    };

    if (
      !endOfThumbnailList &&
      thumbnails.length > 0 &&
      thumbnailsToDisplay.length === thumbnails.length
    ) {
      setInfiniteLoadingMessage(
        "To load more thumbnails, mark these as correct"
      );
    } else if (endOfThumbnailList && cursorDetails.keys.length < 1) {
      setInfiniteLoadingMessage("No data present of the selected date !");
    } else if (endOfThumbnailList) {
      setInfiniteLoadingMessage(
        "You have reached the end of the list of thumbnails, select another node to continue"
      );
    } else {
      setInfiniteLoadingMessage("");
    }

    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [
    thumbnailsToDisplay,
    infiniteLoadingLowerbound,
    infiniteLoadingUpperbound,
  ]);

  useEffect(() => {
    setThumbnailsToDisplay(
      thumbnails.slice(infiniteLoadingLowerbound, infiniteLoadingUpperbound)
    );

    if (thumbnails.length === 0) {
      setThumbnailsToDisplay([]);
      setInfiniteLoadingUpperbound(200);
    }
  }, [thumbnails]);

  //console.log(infiniteLoadingLowerbound,infiniteLoadingLowerbound)
  useEffect(() => {
    console.log("socket obj", socket);
    socket.on("connect", () => {
      console.log("connected");

      socket.on("discardedThumbnails", (msg) => {
        console.log("discarded thumbnails", msg);
      });
    });
  }, []);

  const correctThumbnailsFunc = async () => {
    dispatch(shelfViewFeedbackActions.setLoading(true));
    if (selectedThumbnails.length > 0) {
      dispatch(feedbackActions.setSnackbarOpen(true));
      dispatch(
        feedbackActions.setSnackbarMessage(
          "Selected thumbnails present, Resolve it !"
        )
      );
      dispatch(feedbackActions.setSnackbarMessageSeverity("warning"));
      setTimeout(() => {
        dispatch(feedbackActions.setSnackbarOpen(false));
      }, 5000);
    } else {
      // const response = await axios.post("/get_shelf_data/discard_thumbnails", cursorDetails);
      const thumbnailData = [...cursorDetails.thumbnailDetails];
      // const filteredData = thumbnailData.filter((th) => !selectedThumbnail.some((s) => s.AuditID === th.AuditID));
      const updatedThumbnails = thumbnailData
        .filter((d) => d.activity.verified === 0)
        .map((d) => ({
          ...d,
          issue:"correct",
          activity: {
            ...d.activity,
            verified: 1,
            user: user,
            userID: userId,
            lastModifiedIST: moment
              .utc()
              .tz("Asia/Kolkata")
              .format("YYYY-MM-DD HH:mm:ss"),
            lastModifiedUTC: moment
              .utc(new Date())
              .format("YYYY-MM-DD HH:mm:ss"),
          },
        }));
      //const updatedThumbnails = thumbnailData.map((d) => ({ ...d, activity: { ...d.activity, verified: 1,user:user,userID:userId}}));

      let selectedkeys = updatedThumbnails.map((d) => d.key);
      selectedkeys = [...new Set(selectedkeys)];

      const thumbnails = updatedThumbnails.map((t) => t.thumbnailName);
      //  console.log(thumbnails)

      //   dispatch(thumbnailStoreActions.markAsCorrect(updatedSelectedThumbnails));
      //   dispatch(thumbnailStoreActions.markAsDiscarded(filteredData))

      //  // dispatch(thumbnailStoreActions.updateDiscardedThumbnails());
      const resetData = {
        thumbnailDetails: [],
        currentKey: null,
        lastThumbnailDetails: null,
        endOfThumbnailList: false,
      };
      dispatch(thumbnailStoreActions.updateThumbnailDetailsAndKey(resetData));
      const params = {
        ...cursorDetails,
        updatedThumbnails,
        selectedkeys,
        thumbnails,
      };
      //console.log("parmas",params)
      try {
        const response = await axios.post(
          "/correct_thumbnail_transaction/append_remove_data_from_redis",
          params
        );
        console.log(response.data, "response  ");
        dispatch(
          thumbnailStoreActions.updateThumbnailDetailsAndKey(response.data)
        );
      } catch (error) {
        console.log(error, "error");
      }
    }

    //  console.log(response.data,"datta====")

    dispatch(shelfViewFeedbackActions.setLoading(false));
  };

  //console.log(moment(new Date().toUTCString()).format("YYYY-MM-DD HH:mm:ss"))

  const discardThumbnailsFunc = async (conflictOption) => {
    dispatch(shelfViewFeedbackActions.setLoading(true));

    if (selectedThumbnails.length < 1) {
      dispatch(feedbackActions.setSnackbarOpen(true));
      dispatch(
        feedbackActions.setSnackbarMessage(
          "No Selected thumbnails present, Resolve it !"
        )
      );
      dispatch(feedbackActions.setSnackbarMessageSeverity("warning"));
      setTimeout(() => {
        dispatch(feedbackActions.setSnackbarOpen(false));
      }, 5000);
    } else {
      dispatch(thumbnailStoreActions.updateDiscardedThumbnails());

      const thumbnailData = [...cursorDetails.thumbnailDetails];
      const updatedThumbnails = selectedThumbnails
        // .filter((d) => d.activity.verified === 0)
        .map((d) => ({
          ...d,
          issue:conflictOption,
          activity: {
            ...d.activity,
            verified: 0,
            user: user,
            userID: userId,
            lastModifiedIST: moment
              .utc()
              .tz("Asia/Kolkata")
              .format("YYYY-MM-DD HH:mm:ss"),
            lastModifiedUTC: moment
              .utc(new Date())
              .format("YYYY-MM-DD HH:mm:ss"),
          },
        }));
   console.log(updatedThumbnails)
      const thumbnailsName = updatedThumbnails.map((t) => t.thumbnailName);

      let selectedkeys = updatedThumbnails.map((d) => d.key);
      selectedkeys = [...new Set(selectedkeys)];

      try {
        const response = await axios.post(
          "/markThumbnail/mark_thumbnails_acc_to_issue",
          {
            ...cursorDetails,
            markedThumbnails: updatedThumbnails,
            type_of_issue: conflictOption,
            thumbnailsName: thumbnailsName,
            selectedkeys: selectedkeys,
          }
        );
        //console.log(response)
      } catch (err) {
        console.log(err, "error");
      }

      setSelectedThumbnails([]);
    }

    dispatch(shelfViewFeedbackActions.setLoading(false));
  };
  const nextThumbnailsFunc = async () => {
    dispatch(shelfViewFeedbackActions.setLoading(true));
    try {
      const response = await axios.post(
        "/verfiedThumbnails/get_next_verified_thumbnails",
        { cursorDetails }
      );
      // console.log(response.data)
      dispatch(
        thumbnailStoreActions.updateThumbnailDetailsAndKey(response.data)
      );
    } catch (error) {
      console.log(error);
    }
    dispatch(shelfViewFeedbackActions.setLoading(false));
  };
  const handleClick = (event) => {
    setAnchor(anchor ? null : event.currentTarget);
    dispatch(setOpen(Boolean(anchor ? null : event.currentTarget)));
  };

  const zoomThumbnails = async (customHeight, type) => {
    if (type === "zoom-in") {
      dispatch(shelfViewFeedbackActions.increaseHeight());
    } else {
      dispatch(shelfViewFeedbackActions.decreaseHeight());
    }
    //  dispatch(shelfViewFeedbackActions.setZoomDynamicHeight(customHeight))
    dispatch(shelfViewFeedbackActions.setZoom(type));
  };

  const deleteThumbnailsFunc = async (type) => {
    dispatch(shelfViewFeedbackActions.setLoading(true));

    if (selectedThumbnails.length < 1) {
      dispatch(feedbackActions.setSnackbarOpen(true));
      dispatch(
        feedbackActions.setSnackbarMessage(
          "No Selected thumbnails present, Resolve it !"
        )
      );
      dispatch(feedbackActions.setSnackbarMessageSeverity("warning"));
      setTimeout(() => {
        dispatch(feedbackActions.setSnackbarOpen(false));
      }, 5000);
    } else {
      dispatch(thumbnailStoreActions.updateDiscardedThumbnails());
      const thumbnailsName = selectedThumbnails.map((t) => t.thumbnailName);
      let selectedkeys = selectedThumbnails.map((d) => d.key);
      selectedkeys = [...new Set(selectedkeys)];

      try {
        const response = await axios.post(
          "/remove_thumbnails/discard_thumbnails",
          {
            ...cursorDetails,
            selectedThumbnails: selectedThumbnails,
            thumbnailsName: thumbnailsName,
            selectedkeys: selectedkeys,
          }
        );
        //console.log(response)
      } catch (err) {
        console.log(err, "error");
      }

      setSelectedThumbnails([]);
    }
    dispatch(shelfViewFeedbackActions.setLoading(false));
  };
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  };

  const popupStyle = {
    display: "flex",
    marginLeft: "auto",
    alignSelf: "center",
  };
  const baseStylesThumbnailGrid = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "88vh",
  };

 
  const maxHeight1200 = {
    height: '85vh', 
  };
  const maxHeight1160 = {
    height: '85vh', 
  };
  const maxHeight1150 = {
    height: '83vh', 
  };
  const maxHeight1108 = {
    height: '87.5vh', 
  };
  const maxHeight950 = {
    height: '79vh', 
  };
  const maxHeight821 = {
    height: '85vh', 
  };
  const maxHeight700 = {
    height: '83vh', 
  };
  const maxHeight600 = {
    width: "20vw",
  };
  const maxHeight500 = {
    width: "20vw",
  };

  // Determine which styles to apply based on conditions
  const stylesToApplyToThumbnailGrid = Object.assign(
    {},
    baseStylesThumbnailGrid,
    // window.innerHeight <= 1200 && maxHeight1200,
    // window.innerHeight <= 1160 && maxHeight1160,
   
    // window.innerHeight <= 1000 && maxHeight1000,
    // window.innerHeight <= 950 && maxHeight950,
   
    window.innerHeight <= 739 && maxHeight700,
    // window.innerHeight <= 600 && maxHeight600,
    window.innerHeight <= 821 && maxHeight821,
     window.innerHeight <= 1108 && maxHeight1108,
  );
 console.log(window.innerHeight)
  console.log(thumbnailsToDisplay, window.innerHeight);
  return (
    <Stack sx={{ display: "flex", flexDirection: "row", width: "100%" }}>
      <Stack
        spacing={2}
        className="thumbnail-viewer-container"
        style={containerStyle}
      >
        <ButtonGroup variant="text" aria-label="text button group">
          {cursorDetails.searchMode === "verified" ? (
            <Button
              className="conflict-options "
              onClick={() => nextThumbnailsFunc()}
            >
              Next
            </Button>
          ) : (
            <Button
              className="conflict-options"
              onClick={() => correctThumbnailsFunc()}
            >
              Correct
            </Button>
          )}

          <Button
            className="conflict-options"
            onClick={() => discardThumbnailsFunc("conflicted")}
          >
            Conflicted
          </Button>
          <Button
            className="conflict-options"
            onClick={() => discardThumbnailsFunc("brand")}
          >
            Brand
          </Button>
          <Button
            className="conflict-options"
            onClick={() => discardThumbnailsFunc("flavour")}
          >
            Flavour
          </Button>
          <Button
            className="conflict-options"
            onClick={() => discardThumbnailsFunc("sub-sku")}
          >
            Sub SKU
          </Button>
          <Button
            className="conflict-options"
            onClick={() => discardThumbnailsFunc("size")}
          >
            Size
          </Button>
          <Button
            className="conflict-options"
            onClick={() => discardThumbnailsFunc("others")}
          >
            Others
          </Button>
          <ButtonGroup
            variant="text"
            aria-label="text button group"
            style={{
              backgroundColor: "aliceblue",
              marginLeft: "auto",
              marginRight: "1rem",
            }}
          >
            {selectedZoom === "zoom-in" ? (
              <Button
                className=" selectedZoom"
                onClick={() => zoomThumbnails(250, "zoom-in")}
              >
                <ZoomInIcon />
              </Button>
            ) : (
              <Button
                className="conflict-options"
                onClick={() => zoomThumbnails(10, "zoom-in")}
              >
                <ZoomInIcon />
              </Button>
            )}
            {selectedZoom === "zoom-out" ? (
              <Button
                className="selectedZoom"
                onClick={() => zoomThumbnails(10, "zoom-out")}
              >
                <ZoomOutIcon />
              </Button>
            ) : (
              <Button
                className="conflict-options"
                onClick={() => zoomThumbnails(10, "zoom-out")}
              >
                <ZoomOutIcon />
              </Button>
            )}
            <Button
              className="conflict-options"
              onClick={() => deleteThumbnailsFunc("non-conflicted")}
            >
              <DeleteForeverIcon />
            </Button>
            {/* <Button className="conflict-options" onClick={handleClick}>
              <AnimatedPopup />
            </Button> */}
          </ButtonGroup>
        </ButtonGroup>
        {/* {cursorDetails.endOfThumbnailList&&<div>No conflictDataActions</div>} */}
        <div className="thumbnail-grid">
          {thumbnailsToDisplay.length > 0 &&
            thumbnailsToDisplay.map((r) => (
              <div onClick={() => markAsDiscarded(r)}>
                <GenerateThumbnail {...r} />
              </div>
            ))}

          <div className="infinite-loading-message">
            {infiniteLoadingMessage}
          </div>
        </div>
      </Stack>
      <div
       style={stylesToApplyToThumbnailGrid}
      >
        {toggleRightSidebar ? (
          hoverRightSidebar ? (
            <ArrowCircleRightIcon
              onMouseLeave={handleMouse}
              onClick={toggleSidebarFunc}
              style={{ cursor: "pointer", color: "rgba(73 , 148, 236, 0.875)" }}
            />
          ) : (
            <KeyboardDoubleArrowRightIcon
              onMouseEnter={handleMouse}
              style={{ cursor: "pointer", color: "rgba(73 , 148, 236, 0.875)" }}
            />
          )
        ) : hoverRightSidebar ? (
          <KeyboardDoubleArrowLeftIcon
            onMouseEnter={handleMouse}
            style={{ cursor: "pointer", color: "rgba(73 , 148, 236, 0.875)" }}
          />
        ) : (
          <ArrowCircleLeftIcon
            onClick={toggleSidebarFunc}
            onMouseLeave={handleMouse}
            style={{ cursor: "pointer", color: "rgba(73 , 148, 236, 0.875)" }}
          />
        )}
        {toggleRightSidebar && <AnnotatorRightSidebar />}
      </div>
    </Stack>
  );
};

export default ThumbnailViewer;
